import { useEffect } from "react";
import { unregisterPushOnce } from "../lib/pushUnregister";

let running: Promise<boolean> | null = null;

/**
 * Runs the one-time push unregister at startup, again when the session
 * changes, and on reconnect until it has succeeded. One run at a time.
 */
export function usePushUnregister(signedIn: boolean): void {
  useEffect(() => {
    const run = () => {
      if (running) return;
      running = unregisterPushOnce(signedIn).finally(() => {
        running = null;
      });
    };
    run();
    window.addEventListener("online", run);
    return () => window.removeEventListener("online", run);
  }, [signedIn]);
}
